import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {detailsExpand} from '../../../../common';

@Component({
  selector: 'app-upfront-rejected-claims-dialog',
  templateUrl: './upfront-rejection-claim-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss'],
  animations: [detailsExpand]
})
export class UpfrontRejectionClaimDialogComponent {
  heading = 'Upfront Rejections';
  correlationId: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UpfrontRejectionClaimDialogComponent>,
  ) {
    this.correlationId = this.data.correlationId;
  }
}
